module.exports = __webpack_public_path__ + "img/planting_03.e2ddd34.jpg";